export const STEP = {
  SHARE_ACTIONS: 'SHARE_ACTIONS',
  PUBLISH_TO_EVENT: 'PUBLISH_TO_EVENT',
} as const;

export type TStep = keyof typeof STEP;

export type VideoArea = {
  id: string;
  name: string;
  type: 'stage' | 'session';
};

/**
 * Event Part with both properties set to null represents the Replay Area:
 * { eventPartId: null, eventPartType: null }
 */
export type EventPart =
  | {
      eventPartId: VideoArea['id'];
      eventPartType: VideoArea['type'];
      eventPartName: string;
    }
  | {
      eventPartId: null;
      eventPartType: null;
      eventPartName: null;
    };

export type DraftEventPart = EventPart | null;

export type ReplayEventPartOption = EventPart & {
  kind: 'replay';
  label: string;
};

export type VideoAreaEventPartOption = EventPart & {
  kind: 'video-area';
  videoArea: VideoArea;
};

export type EventPartOption = ReplayEventPartOption | VideoAreaEventPartOption;
